module.exports = __webpack_public_path__ + "img/Vip_Card_7.9180507b.png";